import { useState } from 'react';
import { BellRing } from 'lucide-react';
import { disablePush, enablePush, isStandalone, pushOn, pushSupported } from './push';
import { Button, Card } from './ui';

const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent)
  || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

/* Profile: turn lock-screen rest alerts on for this device. */
export function PushCard({ t, token }) {
  const [on, setOn] = useState(pushOn);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState(null);
  const needsHomeScreen = isIOS() && !isStandalone();

  const toggle = async () => {
    setBusy(true); setMessage(null);
    try {
      if (on) { await disablePush(token); setOn(false); }
      else {
        const problem = await enablePush(token);
        if (problem) setMessage(problem); else { setOn(true); setMessage('On. Your phone buzzes when a rest ends, also when it is locked.'); }
      }
    } catch (e) {
      setMessage('Could not turn alerts on here.');
    }
    setBusy(false);
  };

  return (
    <Card t={t} padding={20}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
        <BellRing size={15} color={on ? t.accent : t.textFaint} />
        <span style={{ fontSize: 14, fontWeight: 700, color: t.text }}>Lock-screen rest alerts</span>
      </div>
      <div style={{ fontSize: 12, color: t.textMuted, lineHeight: 1.45, marginBottom: 12 }}>
        {needsHomeScreen
          ? 'On iPhone this works in the app opened from your home screen: Share > Add to Home Screen, then open it from there and turn this on (iOS 16.4 or newer).'
          : !pushSupported()
            ? 'This browser has no push notifications.'
            : 'A notification when your rest is over, even with the screen locked. You allow it once per device.'}
      </div>
      {!needsHomeScreen && pushSupported() && (
        <Button t={t} size="sm" variant={on ? 'ghost' : 'primary'} disabled={busy || !token} onClick={toggle} style={{ minHeight: 40 }}>
          {on ? 'Turn off on this device' : 'Turn on'}
        </Button>
      )}
      {message && <div style={{ fontSize: 12, color: t.textMuted, marginTop: 10 }}>{message}</div>}
    </Card>
  );
}
